module.exports = __webpack_public_path__ + "static/img/20200904.2cbab11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20200904/20200904.png
// module id = k9O8
// module chunks = 1